// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__34d2M","title":"Images90_title__kn7mX","images":"Images90_images__A8zne"};